import { render } from "./ContinueDialog.vue?vue&type=template&id=6647b0f9&scoped=true"
import script from "./ContinueDialog.vue?vue&type=script&lang=js"
export * from "./ContinueDialog.vue?vue&type=script&lang=js"

import "./ContinueDialog.vue?vue&type=style&index=0&id=6647b0f9&scoped=true&lang=css"

import exportComponent from "/builds/kmkn5581/messequiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6647b0f9"]])

export default __exports__